import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";
import { model, validationModel } from "./AddBankModel";
import history from "@history.js";
import "./AddBank.css";

import { addBanks } from "app/services/MasterAdmin & ApiUSer/BankService";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";

const AddBanks = () => {
  const navigate = useNavigate();
  // const [bankModel, setBankModel] = useState(model);

  const addNewBank = async (values) => {
    const data = await addBanks(values);
    if (data && data.status === "Success") {
      NotificationManager.success(data.message);
      navigate("/master-admin/bank/list");
    } else {
      NotificationManager.error(data.message);
      navigate("/master-admin/bank/list");
    }
  };

  return (
    <div>
      <Helmet>
        <title>Add New Bank</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[
          { name: "Bank Lists", path: "/master-admin/bank/list" },
          { name: "Add New Bank" },
        ]}
      ></Breadcrumb>

      <Card className="m-auto pt-4 px-5">
        <Formik
          initialValues={model}
          validationSchema={validationModel}
          onSubmit={addNewBank}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="form-group  m-auto">
                    <label
                      htmlFor="bankName"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Bank Name
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="bankName"
                      id="bankName"
                      className={
                        touched.bankName && errors.bankName
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Bank Name"
                      value={values.bankName}
                      error={errors.bankName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.bankName}
                    />
                    <p className="text-danger">
                      {touched.bankName && errors.bankName}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-12 ">
                  <div className="form-group m-auto">
                    <label
                      htmlFor="accountNumber"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      A/C Number
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="accountNumber"
                      id="accountNumber"
                      className={
                        touched.accountNumber && errors.accountNumber
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Account Number"
                      value={values.accountNumber}
                      error={errors.accountNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.accountNumber}
                    />
                    <p className="text-danger">
                      {touched.accountNumber && errors.accountNumber}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="row"
                //   style={{ alignItems: "center", paddingLeft: "5px" }}
              >
                <div className="col-md-6 col-12  m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="ifscCode"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      IFSC Code
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="ifscCode"
                      id="ifscCode"
                      className={
                        touched.ifscCode && errors.ifscCode
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="IFSC Code"
                      value={values.ifscCode}
                      error={errors.ifscCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.ifscCode}
                    />
                    <p className="text-danger">
                      {touched.ifscCode && errors.ifscCode}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-12  m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="branch"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Branch
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="branch"
                      id="branch"
                      className={
                        touched.branch && errors.branch
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Branch"
                      value={values.branch}
                      error={errors.branch}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.branch}
                    />
                    <p className="text-danger">
                      {touched.branch && errors.branch}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="row"
                //  style={{ alignItems: "center", paddingLeft: "5px" }}
              >
                <div className="col-md-6 col-12  m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="shortCode"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Bank Short Code
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="shortCode"
                      id="shortCode"
                      className={
                        touched.shortCode && errors.shortCode
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Bank Short Code"
                      value={values.shortCode}
                      error={errors.shortCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.shortCode}
                    />
                    <p className="text-danger">
                      {touched.shortCode && errors.shortCode}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-12  m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="swiftCode"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Swift Code
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="swiftCode"
                      id="swiftCode"
                      className={
                        touched.swiftCode && errors.swiftCode
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Swift Code"
                      value={values.swiftCode}
                      error={errors.swiftCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.swiftCode}
                    />
                    <p className="text-danger">
                      {touched.swiftCode && errors.swiftCode}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="row"
                // style={{ alignItems: "center", paddingLeft: "5px" }}
              >
                <div className="col-md-6 col-12  m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="address"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Address
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      className={
                        touched.address && errors.address
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Address"
                      value={values.address}
                      error={errors.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.address}
                    />
                    <p className="text-danger">
                      {touched.address && errors.address}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-12 m-auto">
                  <div className="form-group">
                    <label
                      htmlFor="remarks"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Remarks
                    </label>
                    <input
                      type="text"
                      name="remarks"
                      id="remarks"
                      className={
                        touched.remarks && errors.remarks
                          ? "error form-control customInput"
                          : "form-control customInput"
                      }
                      placeholder="Remarks"
                      value={values.remarks}
                      error={errors.remarks}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.remarks}
                    />
                    <p className="text-danger">
                      {touched.remarks && errors.remarks}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="row"
                //  style={{ alignItems: "center", paddingLeft: "5px" }}
              >
                <div className="col-md-6 col-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckChecked"
                      name="status"
                      value={values.status}
                      error={errors.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Status
                    </label>
                  </div>
                  {/* <div className="form-group">
                    <label
                      htmlFor="status"
                      className="font-weight-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Status
                    </label>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        name="status"
                        id="status"
                        className="custom-control-input"
                        value={values.status}
                        error={errors.status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                     
                    </div>
                  </div> */}
                </div>

                <div className="col-12 mt-3 mb-3">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
};

export default AddBanks;
